<template>
  <v-expand-transition>
    <div v-if="activeFilters.length > 0" class="mb-5">
      <p class="mb-0 d-inline-block mr-3">
        {{ $t('familiesList.chosenFilters') }}
      </p>
      <TagCustom
        v-for="(item, index) in activeFilters"
        :key="index"
        :text="item.name"
        close
        light
        @callback="close(item)"
      />
      <span
        class="primary-link f-14 font-weight-medium pl-1 pointer d-inline-block"
        @click="removeAllFilters"
      >
        {{ $t('familiesList.removeFilters') }}
      </span>
    </div>
  </v-expand-transition>
</template>

<script>
import TagCustom from '@/components/widgets/TagCustom.vue'

export default {
  name: 'ActiveFilters',
  components: { TagCustom },
  computed: {
    getResourceFilter() {
      return this.$store.getters['families/getResourceFilter']
    },
    categoryFilters() {
      return (this.getResourceFilter && this.getResourceFilter.helpCriteria) || []
    },
    warehouseFilters() {
      return (this.getResourceFilter && this.getResourceFilter.warehouses) || []
    },
    getFilter() {
      return this.$store.getters['families/getFilter']
    },
    getCurrentCategory() {
      return this.getFilter.categoryId
    },
    getCurrentWarehouse() {
      return this.getFilter.warehouseId
    },
    getIsDifficult() {
      return this.getFilter.isDifficult === 1
    },
    activeFilters() {
      const filters = []
      const category = this.categoryFilters.find((el) => {
        return el.support_criterion_id === this.getCurrentCategory
      })
      const warehouse = this.warehouseFilters.find((el) => {
        return el.warehouse_id === this.getCurrentWarehouse
      })
      if (warehouse) {
        filters.push({
          name: this.$t('label.warehouse') + ': ' + warehouse.warehouse_name,
          type: 'warehouse'
        })
      }
      if (category) {
        filters.push({
          name: this.$t('label.familyCategory') + ': ' + category.name,
          type: 'category'
        })
      }
      if (this.getIsDifficult) {
        filters.push({ name: this.$t('label.greaterNeeds'), type: 'difficult' })
      }
      return filters
    }
  },
  methods: {
    removeAllFilters() {
      this.$store.dispatch('families/resetFilter')
    },
    close(item) {
      switch (item.type) {
        case 'warehouse':
          this.$store.commit('families/setFilter', { warehouseId: -1, offset: 1 })
          break
        case 'category':
          this.$store.commit('families/setFilter', { categoryId: -1, offset: 1 })
          break
        case 'difficult':
          this.$store.commit('families/setFilter', { isDifficult: -1, offset: 1 })
          break
      }
    }
  }
}
</script>
